import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AdministrationCompanyState {
  id: any;
  type: any;
  name: any;
  country: any;
  locality: any;
  address: any;
  phone: any[];
  email: any[];
  bankAccount: any;
  bank: any;
  cnp: any;
  signature: any;
  cui: any;
  registrationNumber: any;
  activityDescription: any;
  leadership: any;
  webAddress: any;
  props: {
    [key: string]: any;
  };
}

const initialState: AdministrationCompanyState = {
  id: '',
  type: '',
  name: '',
  country: '',
  locality: '',
  address: '',
  phone: [],
  email: [],
  bankAccount: '',
  bank: '',
  cnp: 0,
  signature: '',
  cui: '',
  registrationNumber: '',
  activityDescription: '',
  leadership: '',
  webAddress: '',
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const administrationCompanySlice = createSlice({
  name: 'administrationCompany',
  initialState,
  reducers: {
    setAdministrationCompany: (state, action: PayloadAction<Partial<AdministrationCompanyState>>) => {
      return { ...state, ...action.payload };
    },

    resetProps: (_state, action: PayloadAction<Partial<AdministrationCompanyState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },

    updateField: (state: AdministrationCompanyState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },
  },
});

export const { setAdministrationCompany, resetProps, updateProps, updateField } = administrationCompanySlice.actions;

export default administrationCompanySlice.reducer;
